import { createAsyncThunk } from '@reduxjs/toolkit';
import { IMaterialType } from './materials.types';
import http from 'src/http'

export const getMaterials = createAsyncThunk<
    IMaterialType,
    void | { subjectId?: number }
>('teacher/materials/getMaterialData', async (params, thunkAPI) => {
    try {
        const { data } = await http.get('/materials/getMaterialDataTeacher', {
            params,
        });
        return data;
    } catch (e) {
        return thunkAPI.rejectWithValue(
            'Не удалось получить данные о материалах!'
        );
    }
});

export const deleteMaterial = createAsyncThunk<unknown, { id: number }>(
    'teacher/materials/deleteMaterial',
    async (params, thunkAPI) => {
        try {
            const { data } = await http.delete('/materials/deleteMaterial', {
                params,
            });
            if (data?.message) return thunkAPI.rejectWithValue(data.message);
            return data;
        } catch (e) {
            return thunkAPI.rejectWithValue('Не удалось удалить материал!');
        }
    }
);